// src/phase4/audio/audio-config.ts
// Audio configuration for Phase 4 tower defense

import type { SoundConfig } from './SoundManager.types';

export { SoundConfig };

// Sound effect configurations
export const SOUND_CONFIGS: SoundConfig[] = [
  // Tower sounds
  {
    key: 'tower_shoot',
    path: '/assets/phase4/audio/towers/shoot.wav',
    volume: 0.6,
    rate: 1.0,
  },
  {
    key: 'tower_shoot_cpu',
    path: '/assets/phase4/audio/towers/shoot_cpu.mp3',
    volume: 0.7,
    rate: 1.0,
  },
  {
    key: 'tower_shoot_lang',
    path: '/assets/phase4/audio/towers/shoot_lang.mp3',
    volume: 0.6,
    rate: 1.0,
  },
  {
    key: 'tower_shoot_net',
    path: '/assets/phase4/audio/towers/shoot_net.mp3',
    volume: 0.5,
    rate: 1.0,
  },
  {
    key: 'tower_upgrade',
    path: '/assets/phase4/audio/towers/upgrade.mp3',
    volume: 0.8,
    rate: 1.0,
  },
  {
    key: 'tower_select',
    path: '/assets/phase4/audio/ui/click.mp3',
    volume: 0.4,
    rate: 1.0,
  },

  // // Enemy sounds
  {
    key: 'enemy_spawn',
    path: '/assets/phase4/audio/enemies/spawn.mp3',
    volume: 0.5,
    rate: 1.0,
  },
  // {
  //   key: 'enemy_damage',
  //   path: '/assets/phase4/audio/enemies/damage.wav',
  //   volume: 0.4,
  //   rate: 1.0,
  // },
  // {
  //   key: 'enemy_die',
  //   path: '/assets/phase4/audio/enemies/die.wav',
  //   volume: 0.6,
  //   rate: 1.0,
  // },
  // {
  //   key: 'enemy_ability',
  //   path: '/assets/phase4/audio/enemies/ability.wav',
  //   volume: 0.5,
  //   rate: 1.0,
  // },

  // Wave sounds
  {
    key: 'wave_start',
    path: '/assets/phase4/audio/waves/start.mp3',
    volume: 0.8,
    rate: 1.0,
  },
  {
    key: 'wave_complete',
    path: '/assets/phase4/audio/waves/complete.mp3',
    volume: 0.7,
    rate: 1.0,
  },
  {
    key: 'wave_all_complete',
    path: '/assets/phase4/audio/waves/all_complete.mp3',
    volume: 0.9,
    rate: 1.0,
  },

  // // Base sounds
  {
    key: 'base_hit',
    path: '/assets/phase4/audio/base/injury.mp3',
    volume: 0.8,
    rate: 1.0,
  },
  {
    key: 'game_over',
    path: '/assets/phase4/audio/base/lose.mp3',
    volume: 0.9,
    rate: 1.0,
  },

  // UI sounds
  {
    key: 'click',
    path: '/assets/phase4/audio/ui/click.mp3',
    volume: 0.4,
    rate: 1.0,
  },
  // {
  //   key: 'ui_hover',
  //   path: '/assets/phase4/audio/ui/hover.wav',
  //   volume: 0.3,
  //   rate: 1.0,
  // },
  // {
  //   key: 'ui_error',
  //   path: '/assets/phase4/audio/ui/error.wav',
  //   volume: 0.5,
  //   rate: 1.0,
  // },
  // {
  //   key: 'ui_success',
  //   path: '/assets/phase4/audio/ui/success.wav',
  //   volume: 0.5,
  //   rate: 1.0,
  // },
];

// Background music configurations
export const MUSIC_CONFIGS: SoundConfig[] = [
  // {
  //   key: 'music_battle',
  //   path: '/assets/phase4/audio/music/battle.ogg',
  //   volume: 0.5,
  //   rate: 1.0,
  // },
  // {
  //   key: 'music_boss',
  //   path: '/assets/phase4/audio/music/boss.ogg',
  //   volume: 0.6,
  //   rate: 1.0,
  // },
  // {
  //   key: 'music_victory',
  //   path: '/assets/phase4/audio/music/victory.ogg',
  //   volume: 0.6,
  //   rate: 1.0,
  // },
];

// Get sound config by key
export function getSoundConfig(key: string): SoundConfig | undefined {
  return SOUND_CONFIGS.find((config) => config.key === key);
}

// Get music config by key
export function getMusicConfig(key: string): SoundConfig | undefined {
  return MUSIC_CONFIGS.find((config) => config.key === key);
}
